import React, {FC} from 'react'
import {Formik, Form, Field, FormikErrors} from 'formik'
import {Input} from '../../../../../_metronic/partials/controls'
import {useIntl} from 'react-intl'
import * as Yup from 'yup'
import axios, {AxiosError} from 'axios'
import {RegisterUserRequest} from '../../../../../redux/reducers/auth/types'

const TokenVerification: FC<TokenVerificationProps> = ({user, onSubmit, btnRef, setLoading}) => {
  const intl = useIntl()
  const [initErrors, setInitError] = React.useState<FormikErrors<RegisterUserRequest>>({})
  const schema = Yup.object().shape({
    token: Yup.string().required(intl.formatMessage({id: 'FORM.ERROR.REQUIRED'})),
  })

  const submit = async ({token, role}: submitTokenFormProps) => {
    try {
      const API_URL = process.env.REACT_APP_API_URL
      setLoading(true)
      const res = await axios.post(`${API_URL}/api/auth/verify/registration-token`, {token})
      setLoading(false)
      const {user} = res.data
      onSubmit({token: user.token, role: user.role})
      setInitError({})
    } catch (error) {
      setLoading(false)
      const err: any = error as AxiosError
      if (err.response?.data.en) {
        setInitError({token: err.response.data[intl.locale]})
      }
    }
  }

  return (
    <Formik
      enableReinitialize={true}
      validationSchema={schema}
      initialValues={user}
      onSubmit={submit}
      errors={initErrors}
    >
      {({handleSubmit, errors, setFieldError}) => {
        if (
          initErrors.token &&
          initErrors.token.trim() !== '' &&
          !errors.token &&
          errors.token !== initErrors.token
        ) {
          setFieldError('token', initErrors.token)
        }

        return (
          <Form>
            <div className='row'>
              <div className='col-sm'>
                <h2 className='fw-bolder d-flex align-items-center text-dark'>
                  {intl.formatMessage({id: 'MENU.TOKEN_VERIFICATION'})}
                  <i
                    className='fas fa-exclamation-circle ms-2 fs-7'
                    data-bs-toggle='tooltip'
                    title='Billing is issued based on your selected account type'
                  ></i>
                </h2>
                <div className='text-gray-400 fw-bold fs-6'>
                  {intl.formatMessage({id: 'MENU.TOKEN_VERIFICATION_DESC'})}
                </div>
              </div>
              <div className='row'>
                <div className='col-sm'>
                  <Field
                    label={intl.formatMessage({id: 'INPUT.TOKEN.LABEL'})}
                    placeholder={intl.formatMessage({id: 'INPUT.TOKEN.PLACEHOLDER'})}
                    name='token'
                    component={Input}
                    required={true}
                  />
                </div>
              </div>
            </div>
            <button
              style={{display: 'none'}}
              type='submit'
              ref={btnRef}
              onSubmit={() => handleSubmit()}
            />
          </Form>
        )
      }}
    </Formik>
  )
}

export interface submitTokenFormProps {
  role: string
  token: string
}

interface TokenVerificationProps {
  onSubmit: (vals: submitTokenFormProps) => void
  user: RegisterUserRequest
  btnRef: any
  setLoading: (val: boolean) => void
}

export default TokenVerification
